import { Input } from '@/components/ui/input';
import { Skeleton } from '@/components/ui/skeleton';
import React, { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import { FieldComponentProps } from './types';

// const FieldView = ({ value }: { value: string }) => {
//   return <p>{String(value)}</p>;
// };

export const TicketTitleField: React.FC<FieldComponentProps> = ({
  formMode,
  controllerField,
  field,
  // form,
}) => {
  const form = useFormContext();
  const [number] = form.watch(['number']);

  let content: ReactElement;
  if (formMode === 'loading') {
    content = (
      <div className="flex gap-2">
        <Skeleton className="h-9 w-9" />
        <Skeleton className="h-9 w-24 grow" />
      </div>
    );
  } else {
    const numberElement = (
      <span className="text-muted-foreground text-2xl">
        #{typeof number === 'number' ? number : '_'}
      </span>
    );
    if (formMode === 'edit') {
      content = (
        <div className="flex w-full items-center gap-2">
          {numberElement}
          <Input {...controllerField} placeholder={field.meta.placeholder} />
        </div>
      );
    } else {
      content = (
        <div className="text-2xl">
          {numberElement} {controllerField.value}
        </div>
      );
    }
  }

  return content;
};
